export const ENVIRONMENT = {
  REACT_APP_API_HOST: process.env.REACT_APP_API_HOST,
  REACT_APP_HOST: process.env.REACT_APP_HOST,
  REACT_APP_BASENAME: null,
  REACT_APP_VERSION: process.env.REACT_APP_VERSION,
  REACT_APP_NAME: process.env.REACT_APP_NAME,
  REACT_APP_FULL_NAME: process.env.REACT_APP_FULL_NAME,
  REACT_APP_STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY || '',
};
